export const MAX_TEST_SKILLS = 10

export function makeTestSkillSchema(agents = []) {
  return [
    {
      type: 'container',
      className: 'details',
      dir: 'row',
      gap: '1.2rem',
      opts: [
        {
          type: 'container',
          gap: '3.2rem',
          opts: [
            {
              field: 'name', 
              title: 'Name', 
              type: 'identifier',
              maxlength: 128, 
              required: true, 
              placeholder: 'skill_name', 
              post_flush: true
            },
            {
              field: 'command', 
              title: 'Command', 
              type: 'command', 
              maxlength: 128, 
              required: true, 
              placeholder: '/customer-support', 
              post_flush: true
            },
          ]
        },
        {
          type: 'container',
          gap: '3.2rem',
          opts: [
            {
              field: 'title', 
              title: 'Title', 
              type: 'text', 
              maxlength: 128, 
              required: true, 
              placeholder: 'Skill title', 
              post_flush: true
            },
            {
              field: 'example', 
              title: 'Example', 
              type: 'text', 
              maxlength: 1024, 
              required: true, 
              placeholder: 'Show an example of how to use this skill', 
              post_flush: true
            },
          ]
        },
      ]
    },
    {
      type: 'container',
      className: 'details',
      gap: '1.2rem',
      dir: 'row',
      opts: [
        {
          field: 'description',
          title: 'Description',
          type: 'text',
          maxlength: 1024,
          required: true,
          post_flush: true,
          placeholder: 'Describe what this skill does'
        },
        {
          field: 'subagents',
          title: 'Subagents',
          type: 'multiselect',
          items: agents,
          placeholder: 'Select Test Agents',
        },
      ]
    },
    {
      className: 'prompt-field',
      field: 'prompt',
      title: 'Prompt',
      type: 'textarea-kb',
      required: true,
      placeholder: 'Add a prompt for this skill',
      maxlength: 50,
    },

  ]
}
